module.exports = __webpack_public_path__ + "img/picture_21.12589185.png";